import { Card, CardContent, Typography, Divider, CardActions, Button, Chip, Stack, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { AxiosInstance } from '../../api/apiInstance';
import { IOrderBaskets } from '../../interface/IOrders_Tasks';
import { useParams } from 'react-router-dom';

function OrderBaskets() {
    // order-basket/findByOrder/67D4B8DD-5EA0-EF11-9F6E-5CC5D4460392'
    let { orderData } = useParams();
    const [showSave, setShowSave] = useState<boolean>(true);
    const [basketInfo, setBasketInfo] = useState<IOrderBaskets[]>([]);
    const [basketId, setBasketId] = useState<string>('');

    useEffect(() => {

        GetData();
    }, [])

    async function GetData() {
        try {
            return await AxiosInstance({
                // url of the api endpoint (can be changed)
                url: 'order-basket/findByOrder/' + orderData,
                method: "GET",
            }).then((res) => {
                // handle success

                setBasketInfo(res.data)
            });
        } catch (e) {
            // handle error
            console.error(e);

        }
    }



    const handleSave = async () => {
        const tmp = {
            basketId: basketId,
            basketRemarks: '',
            order: { id: orderData }
        }
        await AxiosInstance.post('order-basket/', tmp)
            .then(function (response) {
            })
            .catch(function (error) {
                                
                alert(error.response.data.message)
            });
        GetData();
        setBasketId('');
        setShowSave(!showSave)
    };
    const handleDelete = async (e: any) => {
        console.info('You clicked the delete icon.' + e);
        await AxiosInstance.delete('order-basket/' + e)
            .then(function (response) {
            })
            .catch(function (error) {
                console.log(error);
            });
        GetData();
    };
    return (
        <Card sx={{ minWidth: 440, height: 240  }}>

            <Typography component="div" variant="h5">
                Baskets
            </Typography>
            <Divider />
            <CardContent sx={{  minHeight: 110  }}>
                <Stack direction="row" spacing={1}>
                    {basketInfo?.map((bs) => {
                        return (
                            <Chip label={'basket ' + bs.basketId}
                                //id={bs.id}
                                color="warning"
                                onDelete={(e) => { handleDelete(bs.id) }} />
                        )
                    })
                    }
                </Stack>

            </CardContent>
            <Divider />
            <CardActions  >
                {showSave ?
                    <Button
                        //variant="contained"             
                        size='small'
                        variant="outlined"
                        onClick={() => { setShowSave(!showSave) }}>Add basket</Button>
                    : <>
                        <Button
                            //variant="contained"             
                            size='small'
                            variant="outlined"
                            onClick={handleSave}>save</Button>
                        <Button
                            //variant="contained"             
                            size='small'
                            variant="outlined"
                            onClick={() => { setShowSave(!showSave) }}>cancel</Button>
                        <TextField
                            size='small'
                            style={{ padding: 0 }}
                            autoComplete='off'
                            //id="outlined-basic"
                            variant="outlined"
                            value={basketId}

                            onChange={(e) => { setBasketId(e.target.value) }}
                        />
                    </>
                }

                <Button
                    //variant="contained"             
                    size='small'
                    onClick={handleSave}></Button>
            </CardActions>
        </Card>
    )
}

export default OrderBaskets
